module.exports = "/assets/about/hero_mobile.png?VIFr5/x";